import { BENEFICIARY_TYPE_NGO, BENEFICIARY_TYPE_EXISTING } from "constants/index"
import { DEPOSIT_RETENTION_EXCLUSIVE_OFFER, ACCOUNT_RETENTION_EXCLUSIVE_OFFER } from 'constants/flagBasedFeatures';
import transfersHelper from 'utilities/transfersHelper';
import { i18n } from "core/i18n";
const { getLanguage } = i18n;

const CCRequiredFields = [
    'amount',
    'srcIban',
    'language',
    'depositType'
]

const selectTransferFieldsToShowModal = (data) => {
    const { firstStepState, immAccounts, immBankEntity, immBeneficiaries, immFlagBasedFeatures, scheduledId } = data;

    const beneficiaryExistingId = firstStepState.getIn(["beneficiary", "existing", "id"] || '');
    const beneficiaryType = firstStepState.getIn(["beneficiary", "type"]);
    const isNGOBeneficiaryType = firstStepState.getIn(["beneficiary", "type"]) === BENEFICIARY_TYPE_NGO;

    const beneficiaryCountry =
        firstStepState.getIn(["beneficiary", "new", "country"]) ||
        immBeneficiaries.getIn(["byId", beneficiaryExistingId, "country"]);

    const beneficiaryCurrency =
        firstStepState.getIn(["beneficiary", "new", "currency"]) ||
        immBeneficiaries.getIn(["byId", beneficiaryExistingId, "currency"]);

    const isSepa = transfersHelper.isSepa(beneficiaryCountry, beneficiaryCurrency);
    const transferType = isNGOBeneficiaryType ? 'SOLIDARIA' : isSepa ? 'SEPA' : 'NO_SEPA';
    const originAccount = firstStepState.get("fromAccount");
    const originAccountIban = originAccount ? immAccounts.getIn([originAccount, "iban"]) : '';

    let payload;
    let validations;
    if (__CONTACT_CENTER__) {
        validations = {
            amountValid: firstStepState.get('amountIsValid'),
            originAccount: firstStepState.get('fromAccountIban') !== '',
            flag: immFlagBasedFeatures.get(DEPOSIT_RETENTION_EXCLUSIVE_OFFER) || immFlagBasedFeatures.get(ACCOUNT_RETENTION_EXCLUSIVE_OFFER),
        };
        payload = {
            depositType: 'WITHOUT_NEW_MONEY',
            amount: firstStepState.getIn(["amount"]),
            srcIban: originAccountIban,
            language: getLanguage(),
            bankId: '',
            iban: '',
            currency: '',
            transferType: '',
        }
    } else {
        validations = {
            amountValid: firstStepState.get('amountIsValid'),
            originAccount: firstStepState.get('fromAccountIban') !== '',
            flag: immFlagBasedFeatures.get(DEPOSIT_RETENTION_EXCLUSIVE_OFFER) || immFlagBasedFeatures.get(ACCOUNT_RETENTION_EXCLUSIVE_OFFER),
            isIbanValid: firstStepState.getIn(["beneficiary", "new", "ibanIsValid"]) || firstStepState.getIn(["beneficiary", "new", "accountNumberIsValid"]) || beneficiaryType === BENEFICIARY_TYPE_EXISTING,
            scheduledId: !scheduledId
        }
        payload = {
            depositType: 'WITHOUT_NEW_MONEY',
            amount: firstStepState.getIn(["amount"]),
            bankId: firstStepState.getIn(["beneficiary", "new", "bankName"]) || immBankEntity.get('bankName'),
            srcIban: originAccountIban,
            language: getLanguage(),
            iban: firstStepState.getIn(["beneficiary", "new", "iban"]) ||
                firstStepState.getIn(["beneficiary", "existing", "iban"]) ||
                firstStepState.getIn(["beneficiary", "new", "accountNumber"]),
            currency: firstStepState.getIn(["beneficiary", "new", "currency"]) ||
                immBeneficiaries.getIn(["byId", beneficiaryExistingId, "currency"]),
            transferType
        }
    }

    const validationsAreValid = Object.values(validations).every(val => val === true);
    const payloadValuesNotEmpty = __CONTACT_CENTER__
        ? CCRequiredFields.every(key => Boolean(payload[key]))
        : Object.values(payload).every(Boolean);

    return {
        showOffers: validationsAreValid && payloadValuesNotEmpty,
        payload: payload
    }
}

export { selectTransferFieldsToShowModal }